/**
 * @generated SignedSource<<3e2afa39f693cf8dad1217f2c9190c01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceRoutineOccasionsHistoryList_Routine$data = {
  readonly id: string;
  readonly workspaceOccasions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly issueCount: number;
        readonly sequenceNumber: number;
        readonly startAt: string;
        readonly storesCompletedCount: number;
        readonly storesCount: number;
      };
    }>;
  };
  readonly " $fragmentType": "WorkspaceRoutineOccasionsHistoryList_Routine";
};
export type WorkspaceRoutineOccasionsHistoryList_Routine$key = {
  readonly " $data"?: WorkspaceRoutineOccasionsHistoryList_Routine$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceRoutineOccasionsHistoryList_Routine">;
};

const node: ReaderFragment = (function(){
var v0 = [
  "workspaceOccasions"
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "after"
    },
    {
      "kind": "RootArgument",
      "name": "first"
    },
    {
      "kind": "RootArgument",
      "name": "workspaceId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "connection": [
      {
        "count": "first",
        "cursor": "after",
        "direction": "forward",
        "path": (v0/*: any*/)
      }
    ],
    "refetch": {
      "connection": {
        "forward": {
          "count": "first",
          "cursor": "after"
        },
        "backward": null,
        "path": (v0/*: any*/)
      },
      "fragmentPathInResult": [
        "node"
      ],
      "operation": require('./WorkspaceRoutineOccasionsHistoryListRefetchQuery.graphql'),
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "WorkspaceRoutineOccasionsHistoryList_Routine",
  "selections": [
    (v1/*: any*/),
    {
      "alias": "workspaceOccasions",
      "args": [
        {
          "kind": "Variable",
          "name": "workspaceId",
          "variableName": "workspaceId"
        }
      ],
      "concreteType": "RoutineWorkspaceOccasionConnection",
      "kind": "LinkedField",
      "name": "__WorkspaceRoutineOccasionsHistoryList_workspaceOccasions_connection",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "RoutineWorkspaceOccasionEdgeE",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "RoutineWorkspaceOccasion",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "sequenceNumber",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "storesCompletedCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "storesCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "issueCount",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__typename",
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PageInfo",
          "kind": "LinkedField",
          "name": "pageInfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "endCursor",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hasNextPage",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Routine",
  "abstractKey": null
};
})();

(node as any).hash = "7df6ab6fbf0c46192fd114bd7c7110cb";

export default node;
